export const CRM_OBJECT_SELECTOR_PAGES = Object.freeze({
  SELECT: 'SELECT',
  CREATE: 'CREATE'
});
export const FETCH_ALL_PROPS = 'allPropertiesFetchMode';
export const FETCH_ALL_PROPS_VALUE = 'latest_version';
export const CRM_OBJECT_FOLDER_NAME_PROP = 'hs_folder_name';